import { BC_FORM_TYPES } from '../const';
import { types } from './actions';

const initialState = {
  initialValues: null,
  isModalOpen: false,
  isSubmitting: false,
  mode: '',
};

export default (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.BOSTON_CENTERLESS_UPDATE_FLOW_OPEN_MODAL:
      return {
        ...state,
        initialValues: payload.initialValues,
        isModalOpen: true,
        mode: BC_FORM_TYPES.UPDATE,
      };
    case types.BOSTON_CENTERLESS_UPLOAD_FLOW_OPEN_MODAL:
      return {
        ...state,
        initialValues: null,
        isModalOpen: true,
        mode: BC_FORM_TYPES.CREATE,
      };
    case types.BOSTON_CENTERLESS_UPDATE_FLOW_ERROR:
    case types.BOSTON_CENTERLESS_UPLOAD_FLOW_ERROR:
      return {
        ...state,
        isSubmitting: false,
      };
    case types.BOSTON_CENTERLESS_UPDATE_FLOW_SUBMIT:
    case types.BOSTON_CENTERLESS_UPLOAD_FLOW_SUBMIT:
      return {
        ...state,
        isSubmitting: true,
      };
    case types.BOSTON_CENTERLESS_UPDATE_FLOW_SUCCESS:
    case types.BOSTON_CENTERLESS_UPLOAD_FLOW_SUCCESS:
      return {
        ...state,
        initialValues: null,
        isModalOpen: false,
        isSubmitting: false,
      };
    case types.BOSTON_CENTERLESS_FLOW_CLOSE_MODAL:
      return {
        ...state,
        isModalOpen: false,
        isSubmitting: false,
      };
    default:
      return state;
  }
};

export const getScope = (state) =>
  state.modules.customWidgets.bostonCenterlessUploadFlow;

export const getIsModalOpen = (state) => getScope(state).isModalOpen;

export const getIsSubmitting = (state) => getScope(state).isSubmitting;

export const getMode = (state) => getScope(state).mode;

export const getInitialValues = (state) => getScope(state).initialValues;
